import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedDate, FormattedMessage, defineMessages } from 'react-intl';
import FormattedTime from 'components/Intl/formattedTime';
import { serverNow } from 'utils/serverTime';
import { convertDateToVenueTimezone } from 'utils/date';
import { selectVenueTimezone } from 'selectors/root';

const messages = defineMessages({
  menu: {
    defaultMessage: 'Menu',
  },
  service: {
    defaultMessage: 'Service',
  },
  section: {
    defaultMessage: 'Menu Section',
  },
  availableToday: {
    defaultMessage: '{ type } next available at { activeTime }',
  },
  availableTomorrow: {
    defaultMessage: '{ type } next available tomorrow at { activeTime }',
  },
  availableDate: {
    defaultMessage: '{ type } next available { activeDate } at { activeTime }',
  },
});

const venueLocalMidnight = (timestamp, venueTimezone) => {
  const date = new Date(timestamp);
  const venueDate = venueTimezone ? convertDateToVenueTimezone(date, venueTimezone) : date;
  const midnight = new Date(venueDate);
  midnight.setHours(0, 0, 0, 0);
  return midnight.getTime();
};

export const NextAvailableMessage = ({ nextAvailableTime, venueTimezone }) => {
  const now = serverNow();
  const today = venueLocalMidnight(now.getTime(), venueTimezone);

  const venueTomorrowBase = venueTimezone ? convertDateToVenueTimezone(now, venueTimezone) : new Date(now);
  venueTomorrowBase.setDate(venueTomorrowBase.getDate() + 1);
  venueTomorrowBase.setHours(0, 0, 0, 0);
  const tomorrow = venueTomorrowBase.getTime();

  const nextActiveDate = nextAvailableTime.time
    ? venueLocalMidnight(nextAvailableTime.time, venueTimezone)
    : null;

  let message = { ...messages.availableDate };
  if (nextActiveDate === today) {
    message = { ...messages.availableToday };
  } else if (nextActiveDate === tomorrow) {
    message = { ...messages.availableTomorrow };
  }

  const tz = venueTimezone || 'UTC';

  return (
    <FormattedMessage
      {...message}
      values={{
        activeDate: (
          <FormattedDate
            timeZone={tz}
            value={nextAvailableTime.time}
            weekday="long"
            day="numeric"
            month="short"
          />
        ),
        activeTime: <FormattedTime timeZone={tz} value={nextAvailableTime.time} />,
        type: messages[nextAvailableTime.type] ? (
          <FormattedMessage {...messages[nextAvailableTime.type]} />
        ) : (
          ''
        ),
      }}
    />
  );
};

NextAvailableMessage.propTypes = {
  nextAvailableTime: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      type: PropTypes.string,
      time: PropTypes.number,
    }),
  ]),
  venueTimezone: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default connect(state => ({
  venueTimezone: selectVenueTimezone(state),
}))(NextAvailableMessage);
